import React, { Component } from 'react'
import Pagination from 'rc-pagination'
import styled from 'styled-components'
import { func } from 'prop-types'
import { ConditionalRender, FormSelect } from '../../common'
import { genUUID } from '../../../utils/misc'
import 'rc-pagination/assets/index.css'
import './Pagination.css'

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: ${({ justify }) => justify || 'flex-end'};
  margin: ${({ margin, mX, mY, mT, mR, mB, mL }) => `${margin || mY || mT || '0'}px ${margin || mX || mR || '0'}px ${margin || mY || mB || '0'}px ${margin || mX || mL || '0'}px`}
`

const PaginationContainer = styled.div`
  ${({ width = 400 }) => `width: ${width}px`}
`

export default class PaginationComponent extends Component {
  static propTypes = {
    onChangePageSize: func
  }

  selectComponentClass = ({ children, value }, key) => {
    const { onChangePageSize, defaultPageSize, optionsUp, withPageSizeOptions = true, customPageSizeOptions } = this.props
    const options = !withPageSizeOptions
      ? []
      : customPageSizeOptions || [
        { value: 50, label: '50' },
        { value: 100, label: '100' }
      ];
    return <FormSelect width={90} key={key + genUUID()} optionsUp={optionsUp} type='select' direction='row' label='Ver' options={options} onChange={onChangePageSize} value={{ value, label: value }} />
  }

  render () {
    const { justify, margin, mX, mY, mT, mR, mB, mL, total } = this.props
    return (
      <ConditionalRender condition={total}>
        <PaginationWrapper margin={margin} mX={mX} mY={mY} mT={mT} mR={mR} mB={mB} mL={mL}>
          <PaginationContainer>
            <Pagination
              total={total}
              style={{ display: 'flex', justifyContent: justify || 'flex-end', alignItems: 'center', marginBottom: 0 }}
              selectComponentClass={this.selectComponentClass}
              showSizeChanger
              defaultCurrent={1}
              showLessItems
              showTitle={false}
              {...this.props}
            />
          </PaginationContainer>
        </PaginationWrapper>
      </ConditionalRender>
    )
  }
}
